module.exports = __webpack_public_path__ + "img/app1.8bbbf662.png";